import { useMemo, useCallback } from 'react';

import api, { actioncablePath } from '../../api/Schema/Api';
import {
  openAndConnectConsumer,
  disconnectConsumer,
  subscribe as openSubscription,
  unsubscribe as closeSubscription,
  say as sayChannel,
} from '@rails/cable';

export const useCable = () => {
  const connect = useCallback((actions) => {
    const url = new URL(actioncablePath, api.baseUrl);
    const token = api.getJWT();
    openAndConnectConsumer(url, token);
  }, []);

  const disconnect = useCallback((subscription) => {
    disconnectConsumer();
  }, []);

  const subscribe = useCallback(
    (actions) => {
      connect();

      const subscription = openSubscription(
        { channel: 'SessionChannel' },
        {
          ...actions,
          onConnected(arg) {
            actions.onConnected?.bind(this)(arg);
          },
          onDisconnected(arg) {
            actions.onDisconnected?.bind(this)(arg);
          },
          onReceived(arg) {
            actions.onReceived?.bind(this)(arg);
          },
          onRejected: () => {
            throw Error('Session subscription rejected');
          },
        },
      );
      return subscription;
    },
    [connect],
  );

  const unsubscribe = useCallback((subscription) => {
    if (!subscription) return;

    closeSubscription(subscription);
  }, []);

  const say = useCallback(
    (subscription, action, params) =>
      sayChannel(subscription, 'say', { verb: action, params }),
    [],
  );

  return useMemo(
    () => ({
      disconnect,
      subscribe,
      unsubscribe,
      say,
    }),
    [disconnect, unsubscribe, subscribe, say],
  );
};
